<template>
  <div class="flex flex-row gap-4 items-center justify-center">
    <div
      v-if="hasSelection"
      class="text-sm h-10 px-4 flex justify-center items-center text-woot-600 bg-woot-100 rounded-[5px]"
    >
      <span v-if="isSelectAllStorage">
        {{
          $t('FILE_STORAGE.SELECT_ALL.ALL_SELECTED_BADGE', {
            total: meta.all_count,
          })
        }}
      </span>
      <span v-else>
        {{
          $t('FILE_STORAGE.NUMBER_OF_FILE_SELECTED', {
            amount: selectedRows.length,
          })
        }}
      </span>
    </div>
    <woot-button
      v-if="hasDeletePermission('File Storage')"
      size="medium"
      variant="smooth"
      color-scheme="alert"
      icon="delete"
      :is-disabled="disableDeleteButton"
      @click="openConfirmDeleteModal"
    >
      {{ $t('FILE_STORAGE.DELETE.BUTTON') }}
    </woot-button>
    <woot-modal
      :show.sync="showConfirmDeleteModal"
      :on-close="hideConfirmDeleteModal"
    >
      <div class="h-auto overflow-auto flex flex-col">
        <woot-modal-header
          :header-title="$t('FILE_STORAGE.DELETE.MODAL_TITLE')"
        />
        <div class="flex flex-col gap-4 px-8 pt-4">
          <div>
            {{
              $t('FILE_STORAGE.DELETE.MODAL_CONTENT.SENTENCE_1', {
                amount: isSelectAllStorage
                  ? meta.all_count
                  : selectedRows.length,
              })
            }}
          </div>
          <div>{{ $t('FILE_STORAGE.DELETE.MODAL_CONTENT.SENTENCE_2') }}</div>
        </div>
        <div class="flex flex-row justify-end gap-2 px-8 pt-4 pb-8 w-full">
          <button class="button clear" @click.prevent="hideConfirmDeleteModal">
            {{ $t('FILE_STORAGE.DELETE.MODAL_BUTTON.CANCEL') }}
          </button>
          <woot-button
            :is-loading="uiFlags.isDeleting"
            @click="deleteAttachments"
          >
            {{ $t('FILE_STORAGE.DELETE.MODAL_BUTTON.DELETE') }}
          </woot-button>
        </div>
      </div>
    </woot-modal>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import hasPermissionMixin from 'dashboard/mixins/hasPermission';

export default {
  mixins: [hasPermissionMixin],
  data() {
    return { showConfirmDeleteModal: false };
  },
  computed: {
    ...mapGetters({
      selectedRows: 'fileStorage/getSelectedRows',
      uiFlags: 'fileStorage/getUIFlags',
      isSelectAllStorage: 'fileStorage/isSelectAllStorage',
      meta: 'fileStorage/getMeta',
    }),
    hasSelection() {
      return this.isSelectAllStorage || this.selectedRows.length > 0;
    },
    disableDeleteButton() {
      return !this.isSelectAllStorage && this.selectedRows.length === 0;
    },
  },
  methods: {
    openConfirmDeleteModal() {
      this.showConfirmDeleteModal = true;
    },
    hideConfirmDeleteModal() {
      this.showConfirmDeleteModal = false;
    },
    async deleteAttachments() {
      this.$store.commit('fileStorage/SET_UI_FLAG', {
        isDeleting: true,
      });
      try {
        await this.$store.dispatch('fileStorage/deleteAttachments');
        bus.$emit(
          'newToastMessage',
          this.$t('FILE_STORAGE.DELETE.SUCCESS_MESSAGE')
        );
      } catch (e) {
        const isPermissionDenied = e?.response?.status === 403;
        bus.$emit(
          'newToastMessage',
          this.$t(
            isPermissionDenied
              ? 'FILE_STORAGE.DELETE.PERMISSION_DENIED_MESSAGE'
              : 'FILE_STORAGE.DELETE.FAILED_MESSAGE'
          )
        );
      }
      this.showConfirmDeleteModal = false;
    },
  },
};
</script>
